import { InitializeMoralRiskStudyCommand } from './../../../domain';

export type InitializeMoralRiskStudyResponseDto = {
  initializeMoralStudy: {
    value: string;
  };
};

export type InitializeMoralStudyDto = {
  dateOfBirth: number;
};

export type InitializeMoralRiskStudyRequestDto = {
  input: InitializeMoralStudyDto;
};

export const mapInitializeMoralRiskStudyCommandToDto = (
  command: InitializeMoralRiskStudyCommand
): InitializeMoralRiskStudyRequestDto => {
  return {
    input: {
      dateOfBirth: command.dateOfBirth.value,
    },
  };
};
